<template>
  <div class="wrapper" v-if="updateSide">
    <router-link to="/assistenzhunde"><img src="/img/aside/aside1.png"></router-link>
    <router-link to="/story-atelier"><img src="/img/aside/aside3.png"></router-link>
    <router-link to="/ausstellung"><img src="/img/aside/aside2.png"></router-link>
  </div>
  <div class="wrapper" v-else>
    <router-link to="/assistenzhunde"><img src="/img/aside/small1.png"></router-link>
    <router-link to="/story-atelier"><img src="/img/aside/small2.png"></router-link>
    <router-link to="/ausstellung"><img src="/img/aside/small3.png"></router-link>
  </div>
</template>

<style scoped>
.wrapper {
  height:100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

img{
  width:120px;
  margin-bottom:-4px;
  flex-grow: 1;
}


@media (orientation: landscape) and (max-width:981px){
.swiper-button-white{
  display:none;
}
.wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
img{
  width:138px;
  margin-bottom:-4px;
  flex-grow: 1;
}

}

@media (orientation: landscape) and (min-height:768px) {
  .wrapper {
    height:100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  img{
    width:137px;
  }
}

@media (orientation: landscape) and (max-height: 414px) {
  img{
    width:137px;
  }
}

@media (orientation: landscape) and (max-height: 411px) {
  img{
    width:137px;
  }
}

@media (orientation: landscape) and (max-height: 375px) {
  img{
    width:125px;
  }
}

@media (orientation: landscape) and (max-height: 360px) {
  img{
    width:120px;
  }
}

@media (orientation: landscape) and (max-height: 320px) {
  img{
    width:106px;
  }
}

@media (orientation: portrait) and (min-width: 981px) {
  div{
  }
  img{
    width:138px;
    margin-bottom:-4px;
  }
}
@media (orientation: portrait) and (min-width: 737px) and (max-width: 980px) {
  .wrapper {
    height:100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  img {
    width:137px;
    height: auto;
    margin-bottom:-4px;
  }
 }
@media (orientation: portrait) and (max-width: 736px) {
  .wrapper {
    height:100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  img {
    width:137px;
    height: auto;
    margin-bottom:-4px;
  }
 }

@media (orientation: portrait) and (max-width: 375px) {
  img {
    width:137px;
    height: auto;
    margin-bottom:-4px;
  }
 }

@media (orientation: portrait) and (max-width: 360px) {
  img {
    width:137px;
    height: auto;
    margin-bottom:-4px;
  }
 }

</style>

<script>
export default {
  name: 'Side',
  data () {
    return {
      responsive: true
    }
  },
  computed: {
    updateSide () {
      return this.responsive
    },
    showSubMenu () {
      return this.$store.state.showSubMenu
    }
  },
  methods: {
    changeSide () {
      if (window.innerWidth < 800) {
        this.responsive = false
      } else {
        this.responsive = true
      }
      if (window.innerWidth < 900 && window.innerHeight < 500) {
        this.responsive = false
      }
    }
  },
  mounted () {
    this.changeSide()
    window.addEventListener('resize', this.changeSide)
  }
}
</script>
